import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

export interface SystemUsageDailyView {
  /** yyyy-MM-dd (ค.ศ.) */
  date: string;
  totalRequests: number;
  reviewed: number;
  pendingReview: number;
  pendingApproval: number;
  approved: number;
  rejected: number;
  ecodingCodes: number;
}

export interface SystemUsageMonthlyView {
  /** วันแรกของเดือน yyyy-MM-dd (ค.ศ.) */
  month: string;
  totalRequests: number;
  passInspection: number;
  passInspectionPct: number;
  approved: number;
  approvalPct: number;
  ecodingCodes: number;
  avgDurationDays: number | null;
  pendingRequests: number;
}

export interface SystemUsageYearlyView {
  /** ปี ค.ศ. */
  year: number;
  totalRequests: number;
  totalApproved: number;
  ecodingCodesAssigned: number;
  approvalRate: number;
  avgDurationDays: number | null;
  trend: string;
}

export interface SystemUsageSummaryResponse {
  dateStart: string;
  dateEnd: string;
  year: number;
  daily: SystemUsageDailyView[];
  monthly: SystemUsageMonthlyView[];
  yearly: SystemUsageYearlyView[];
}

export interface SystemUsageSummaryParams {
  dateStart?: string;
  dateEnd?: string;
  year?: number;
}

@Injectable({providedIn: 'root'})
export class SystemUsageSummaryService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = '/api/system-usage-summary';

  summarize(params: SystemUsageSummaryParams): Observable<SystemUsageSummaryResponse> {
    const query: Record<string, string> = {};
    if (params.dateStart) {
      query['dateStart'] = params.dateStart;
    }
    if (params.dateEnd) {
      query['dateEnd'] = params.dateEnd;
    }
    if (params.year) {
      query['year'] = String(params.year);
    }
    return this.http.get<SystemUsageSummaryResponse>(this.baseUrl, {params: query});
  }
}
